import { MealType } from '../enums';
import { z } from 'zod';

import { CoverSourceName, MediaSourceValue } from './asset-source';
import { Translation } from './translation';
import { GroceryUnitEnum } from './grocery';

export const MealTypeEnum = z.enum([
  MealType.BREAKFAST,
  MealType.DINNER,
  MealType.LUNCH,
  MealType.SNACK,
  MealType.HYDRATION,
]);

export const MealGroceryDto = z.object({
  groceryId: z.string().uuid(),
  quantity: z.number().nonnegative(),
  unit: GroceryUnitEnum,
  quantityPerPc: z.number().nonnegative().optional(),
});

export const CreateMealDto = z.object({
  /**
   * "Copy template": the meal this one was copied from. The copy is built in
   * the browser, so this is the only way the server learns its source — a
   * copy of purchased content is recorded as purchase-derived and can never
   * be listed (9.6 follow-up). It restricts only the new row.
   */
  copiedFromMealId: z.string().uuid().optional(),
  coverSource: CoverSourceName.optional(),
  coverType: z.string().optional(),
  mediaType: z.string().optional(),
  mediaSource: MediaSourceValue.optional(),
  tags: z.array(z.string()).optional(),
  translations: z.array(Translation),
  groceries: z.array(MealGroceryDto).optional(),
  configuration: z
    .object({
      isOrg: z.boolean().optional(),
    })
    .optional(),
});

export type ApiCreateMealDto = z.infer<typeof CreateMealDto>;

export const UpdateMealDto = z
  .object({
    coverSource: CoverSourceName.optional().nullable(),
    coverType: z.string().optional(),
    mediaType: z.string().optional(),
    mediaSource: MediaSourceValue.optional(),
    tags: z.array(z.string()).optional(),
    translations: z.array(Translation).optional(),
    groceries: z.array(MealGroceryDto).optional(),
    configuration: z
      .object({
        isOrg: z.boolean().optional(),
        marketplace: z
          .object({
            enabled: z.boolean(),
            price: z.number().nonnegative().optional(),
            currency: z.string().optional(),
          })
          .optional(),
      })
      .optional(),
  })
  .strict();

export type ApiUpdateMealDto = z.infer<typeof UpdateMealDto>;
